import { Step } from '@seek/hirer-team-member-job-access';
import { useTranslations } from '@vocab/react';

import { NOTIFICATION_WIDGET_CUSTOM_EMAIL_DISPLAYED } from 'src/app/shared/dataAnalytics/schema/constants';

import { useHandleSaveJobAccessAndNotify } from '../../hooks/useHandleSaveJobAccessAndNotify';
import {
  sendNotificationsImpressionEvents,
  sendSetTeamEmailBackEvent,
} from '../../utils/sendNotificationsSettingEvents';
import { StepTeamEmailPanel } from '../StepTeamEmailPanel';

import translations from './.vocab';

interface Props {}

export const StepTeamEmail = ({ ...stepperProps }: Props): JSX.Element => {
  const { t } = useTranslations(translations);
  const handleSaveJobAccessAndNotify = useHandleSaveJobAccessAndNotify();

  const onActive = () => {
    sendNotificationsImpressionEvents(
      NOTIFICATION_WIDGET_CUSTOM_EMAIL_DISPLAYED,
    );
  };

  const onSendTeamEmailBack = () => sendSetTeamEmailBackEvent();

  return (
    <Step
      onClickNextAsync={handleSaveJobAccessAndNotify}
      saveButtonLabel={t('step-team-email')}
      onActive={onActive}
      onClickGoBack={onSendTeamEmailBack}
      {...stepperProps}
    >
      <StepTeamEmailPanel />
    </Step>
  );
};
